import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Shimmer from 'react-shimmer-effect';

import { FiPower, FiTrash2 } from 'react-icons/fi';

import giveahandLogo from '~/assets/logo.png';

import colors from '~/styles/colors';

import {
  Container,
  Header,
  RegisterLink,
  LogoutButton,
  Content,
  RemoveButton,
} from './styles';

import Footer from '~/components/Footer';
import LoadingLine from '~/components/LoadingLine';

import history from '~/services/history';
import api from '~/services/api';

export default function Profile() {
  const respId = localStorage.getItem('respId');
  const respName = localStorage.getItem('respName');

  const [loading, setLoading] = useState(false);
  const [indications, setIndications] = useState([]);

  useEffect(() => {
    document.title = 'Give A Hand | Profile';
  });

  useEffect(() => {
    async function loadIndications() {
      try {
        setLoading(true);

        const response = await api.get('/profile', {
          headers: {
            Authorization: respId,
          },
        });

        const { data } = response;

        setIndications(data);
      } catch (error) {
        toast.error('Houve um erro ao tentar carregar as idicações.');
      }

      setLoading(false);
    }

    loadIndications();
  }, [respId]);

  async function handleDelete(id) {
    try {
      await api.delete(`/indications/${id}`, {
        headers: {
          Authorization: respId,
        },
      });

      toast.success('Indicação deletada com sucesso.');

      setIndications(
        indications.filter(currentIndication => currentIndication.id !== id)
      );
    } catch (error) {
      toast.error('Erro ao deletar indicação. Tente novamente.');
    }
  }

  function handleLogout() {
    localStorage.clear();

    history.push('/');
  }

  return (
    <Container>
      <Header>
        <div>
          <img src={giveahandLogo} alt="Give A Hand" />
          <span>
            Bem-vindo(a), <span>{respName}</span>
          </span>
        </div>

        <div>
          <RegisterLink to="/indications/new">Cadastrar indicação</RegisterLink>

          <LogoutButton onClick={handleLogout}>
            <FiPower size={18} color={colors.danger} />
          </LogoutButton>
        </div>
      </Header>
      <Content>
        <div className="title-group">
          <h1>Indicações cadastradas</h1>
          <a href="/indications" target="_blank">
            Visualizar todas as indicações
          </a>
        </div>
        <ul>
          {loading ? (
            <>
              <li>
                <Shimmer>
                  <LoadingLine />
                </Shimmer>
              </li>
              <li>
                <Shimmer>
                  <LoadingLine />
                </Shimmer>
              </li>
            </>
          ) : (
            indications.map(item => (
              <li key={item.id}>
                <strong>NOME:</strong>
                <p>{item.indication_name}</p>

                <strong>CARGO:</strong>
                <p>{item.indication_position}</p>

                <strong>E-MAIL:</strong>
                <p>
                  <a href={`mailto:${item.indication_email}`}>
                    {item.indication_email}
                  </a>
                </p>

                <strong>WHATSAPP:</strong>
                <p>{item.indication_whatsapp}</p>

                <strong>LINKEDIN:</strong>
                <p>
                  <a
                    href={`${item.indication_linkedin}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.indication_linkedin}
                  </a>
                </p>

                <strong>CIDADE:</strong>
                <p>
                  {item.indication_city !== null
                    ? item.indication_city
                    : 'Não informado'}
                </p>

                <strong>ESTADO:</strong>
                <p>
                  {item.indication_state !== null
                    ? item.indication_state
                    : 'Não informado'}
                </p>

                <strong>CIDADE DE INTERESSE:</strong>
                <p>
                  {item.indication_city_interest !== null
                    ? item.indication_city_interest
                    : 'Não informado'}
                </p>

                <RemoveButton onClick={() => handleDelete(item.id)}>
                  <FiTrash2 size={18} color={colors.grey3} />
                </RemoveButton>
              </li>
            ))
          )}
          {!indications.length && !loading && (
            <li>
              Nenhuma indicação cadastrada!{' '}
              <Link to="/indications/new">Cadastre agora mesmo.</Link>
            </li>
          )}
        </ul>
      </Content>

      <Footer />
    </Container>
  );
}
